import * as React from "react"
import * as SeparatorPrimitive from "@radix-ui/react-separator"

import { cn } from "../../lib/utils";
import {
    SEPARATOR_BASE_CLASSES,
    SEPARATOR_HORIZONTAL_CLASSES,
    SEPARATOR_VERTICAL_CLASSES,
    DEFAULT_ORIENTATION,
    DEFAULT_DECORATIVE
} from "./constants"
import { SeparatorProps } from "./types"

const Separator = React.forwardRef<
    React.ElementRef<typeof SeparatorPrimitive.Root>,
    SeparatorProps
>(
    (
        { className, orientation = DEFAULT_ORIENTATION, decorative = DEFAULT_DECORATIVE, ...props },
        ref
    ) => (
        <SeparatorPrimitive.Root
            ref={ref}
            decorative={decorative}
            orientation={orientation}
            className={cn(
                SEPARATOR_BASE_CLASSES,
                orientation === "horizontal" ? SEPARATOR_HORIZONTAL_CLASSES : SEPARATOR_VERTICAL_CLASSES,
                className
            )}
            {...props}
        />
    )
)
Separator.displayName = SeparatorPrimitive.Root.displayName

export { Separator } 